<template>
  <div v-if="loaded">
     <div class="md-layout-item md-size-100 page">
            <div class="section_body">
                <div class="section_title">
                <h2>COVID-19 IMPACT </h2>
                <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                </div>

                 <div class="tble-box">
                    <div class="tbl-title">
                    <h4>  Month-to-Month Employment-Sales </h4>
                    </div>  
                    <div class="inner-tbl">
                            <md-table v-model="covid"  
                               table-header-color="blue"
                                class="dark_blue"
                                style="flex: 1;">
                                    <md-table-row
                                    slot="md-table-row"
                                    slot-scope="{ item }"
                                    >
                                    <md-table-cell
                                    class="md-table-side-label"
                                    >{{ item.name }}</md-table-cell
                                    >
                                    <md-table-cell
                                    v-for="(key, index) in item.dates"
                                    :key="key"
                                    :md-label="covidColumns[index]"
                                    >{{ key }}
                                    </md-table-cell>
                                    </md-table-row>
                            </md-table>
                           
                    </div> 
                 </div>
            </div> 

             <div class="section_body">

                 <div class="tble-box">
                    <div class="tbl-title">
                    <h4>  % Change from Dec-19</h4>
                    </div>  
                    <div class="inner-tbl">
                        <md-table
                        v-model="covidChange"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                        >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell
                                class="md-table-side-label"
                                >{{ item.name }}</md-table-cell
                              >
                              <md-table-cell
                                v-for="(key, index) in item.dates"
                                :key="key"
                                :md-label="
                                  covidChangeColumns[index]
                                "
                                >{{ key }}
                              </md-table-cell>
                            </md-table-row>
                        </md-table>
                    </div> 
                 </div>
            </div>      
            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
    </div>
    
  </div>
</template>

<script>
import { NavTabsCard, ChartCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import moment from 'moment'
export default {
  components: {
   // ChartCard,
  },
  mixins: [formatData],
  data() {
    return {
      view: 'Industry COVID-19',
      loaded:false,
      moment: moment,
      inssightsindustrycovid:'',
    };
  },
  computed: {
     ...mapState({
      user: (state) => state.user.user,
    }),
    releaseDate() {
      return this.$store.getters.releaseDate;
    },

    ifInfo() {
      return this.$store.getters.profileInfo;
    },
    covid() {
      let covid = this.ifInfo.covid;

      let result = Object.keys(covid).map((key, index) => {
        return {
          name: key,
          dates: covid[key],
        };
      });
      return result;
    },
    covidColumns() {
      return this.ifInfo.covidColumns;
    },
    covidChange() {
      let covidChange = this.ifInfo.covidChange;

      let result = Object.keys(covidChange).map((key, index) => {
        return {
          name: key,
          dates: covidChange[key],
        };
      });
      return result;
    },
    covidChangeColumns() {
      return this.ifInfo.covidChangeColumns;
    },
   
  },
  mounted() {
       this.inssightsindustrycovid=1;
  },
  watch: {
      inssightsindustrycovid(newVal, oldVal) {
      this.init();
    }
  },
  methods: {
    init(){
          let section = this.$route.query.section;
          if (!section) {
          section = 'cash-flow-solvency';
          }
       
          this.loaded=true;
    },

     numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    
   
  },
};

</script>
